export default __webpack_public_path__ + "static/media/add-member.ba1fe1a1.svg";